import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.loading = false;
    this.rules = {};
  }
  get lang() {
    return AppModule.language;
  }
};
__decorate([Prop({
  default: null
})], default_1.prototype, "ordersProduct", void 0);
default_1 = __decorate([Component({
  name: 'DealerDetails'
})], default_1);
export default default_1;